module.exports = __webpack_public_path__ + "static/media/20700_SN_GA_TM5_ES_V2.9a7990c0.pdf";